var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{
    'sidebar-header': true,
    'sidebar-header--collapsed': _vm.isCollapsed,
  }},[_c('div',{staticClass:"sidebar-header__inner"},[_c('div',{staticClass:"partner-logo-container"},[(_vm.isCollapsed)?_c('svg-icon',{attrs:{"icon-class":"partner-logo"}}):_c('svg-icon',{attrs:{"icon-class":_vm.tamaraBusinessLogo,"width":"141px","height":"16px","color":"#fff"}})],1),(_vm.collapseButtonVisible)?_c('div',{staticClass:"controller-button"},[_c('svg-icon',{attrs:{"icon-class":_vm.sidebarControllerButtonName},on:{"click":_vm.handleToggleSidebar}})],1):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }